import { useLocale } from "../../../context/LanguageContext";

interface OrganizationStatusBadgeProps {
  isActive: boolean;
}

export function OrganizationStatusBadge({ isActive }: OrganizationStatusBadgeProps) {
  const { t } = useLocale();
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${
        isActive
          ? "bg-success/10 text-success"
          : "bg-destructive/10 text-destructive"
      }`}
    >
      <span
        className={`mr-1.5 inline-block h-1.5 w-1.5 rounded-full ${
          isActive ? "bg-success" : "bg-destructive"
        }`}
      />
      {isActive ? t("organizations.status.active") : t("organizations.status.suspended")}
    </span>
  );
}
